export default [
  {
    path: '/control_calidad/despacho/preembarque',
    name: 'preembarquere',
    component: () => import('@/views/control_calidad/despacho/preembarque.vue'),
    meta: {
      pageTitle: 'Listar Preembarques',
      breadcrumb: [
        {
          text: 'Preembarques',
        },
        {
          text: 'Listar Preembarques',
          active: true,
        },
      ],
      resource: 'Preembarque Re',
      action: 'menu',
    },
  },
  {
    path: '/control_calidad/despacho/embarque',
    name: 'embarquere',

    component: () => import('@/views/control_calidad/despacho/embarque.vue'),
    meta: {
      pageTitle: 'Listar Embarques',
      breadcrumb: [
        {
          text: 'Embarques',
        },
        {
          text: 'Listar Embarques',
          active: true,
        },
      ],
      resource: 'Embarque Re',
      action: 'menu',
    },
  },

]
